import React, { Component } from 'react';

import './style.css';


export default class ConfirmEvent extends Component {
  render() {
    const classes = this.props.styleClasses ? this.props.styleClasses.join(' ') : '';
    return (
      <div className={classes + ' form__info-block'}>
        <div className='form__tips'>
          Конференция пройдет в&nbsp;2&nbsp;дня. В субботу мы поговорим о&nbsp;веб-дизайне, менеджменте  IT-проектов, стартапах и soft&nbsp;skills. А&nbsp;воскресенье посвятим обзору отраслей программирования.
        </div>
        <div className='form__inputs'>
          <label className='form__label'>Пожалуйста, выберите:</label>
          {this.props.children}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/blocks/form-blocks/ConfirmEvent.js